
const CephesWrapper = require('./cephes-wrapper.js');

// Compile async in the browser
module.exports = new CephesWrapper(false);
